<template>
  <BaseButton
    text
    color="white"
    retain-focus-on-click
    :ripple="false"
    :disabled="isDisabled"
    @click="deleteAnnotation()"
  >
    <BaseSpriteIcon icon-name="ico-delete"></BaseSpriteIcon>
    <span class="context-menu-text-item">{{ $t('Context.short.delete') }}</span>
  </BaseButton>
</template>

<script>
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';
import BaseButton from '@/components/base/BaseButton/BaseButton';

export default {
  name: 'DeleteAnnotationControl',
  components: {
    BaseSpriteIcon,
    BaseButton
  },
  computed: {
    bookId() {
      const openParams = this.$store.getters[
        'OpenParameterStore/getPublicationOpenParameters'
      ];
      return openParams?.publicationId;
    },
    isDisabled() {
      return this.$attrs.hasOwnProperty('disabled')
        ? this.$attrs.disabled
        : false;
    }
  },
  methods: {
    selectedLocator() {
      return this.$store.getters['MaterialsStore/getSelectedLocator'];
    },
    getAnnotationFullSelectedByLocator() {
      return this.$store.getters[
        'AnnotationsStore/getAnnotationFullSelectedByLocator'
      ](this.selectedLocator(), this.bookId);
    },
    deleteAnnotation() {
      const annotation = this.getAnnotationFullSelectedByLocator();
      this.$store.dispatch('AnnotationsStore/deleteAnnotation', {
        annotation
      });
    }
  }
};
</script>
